<template>
    <q-input
            :model-value="modelValue"
            label="Search users"
            clear-icon="fa fa-times"
            clearable
            v-bind="$attrs"
            @update:model-value="delayedSearch"
            @clear="$emit('update:modelValue', null)">
        <template v-slot:prepend>
            <q-icon name="fa fa-search" />
        </template>
    </q-input>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';

export default defineComponent({
  emits: ['update:modelValue'],
  props: {
    modelValue: String,
  },
  methods: {
    onInput(keyword: string): void {
      this.$emit('update:modelValue', keyword);
    },
    delayedSearch: _.debounce(function search(this: any, input: string) {
      this.onInput(input);
    }, 1000),
  },
});
</script>
